<div style="width: 100%; height: 100%">
  <div
    class="column-layout height100p"
    style="width: calc(100%- 32px); padding: 1rem"
    #docwrapper
    *ngIf="_showTable"
  >
    <div #doctable style="height: 40vh; overflow-y: auto">
      <table class="orders-documents-table" *ngIf="_type === 'all'">
        <thead
          class="bg-white pos-relative"
          style="top: 0; left: 0; z-index: 1000"
        >
          <tr>
            <th
              class="cb-column"
              style="background-color: white"
              *ngIf="!isReadonly"
            >
              <mat-checkbox
                [checked]="allSelected"
                (change)="selectAllDocuments($event)"
              ></mat-checkbox>
            </th>
            <th>Ausgefüllt</th>
            <th>Sichtbar für Montage</th>
            <th style="max-width: 30vw">Name</th>
            <th>Geändert am</th>
            <th>Geändert von</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of rowDataDocs; let $idx = index">
            <tr
              [id]="'doc_row_' + item.id"
              [ngClass]="{
                'table-grey-bg': $idx % 2 === 0 && !item.selected,
                'light-bg-color': item.selected,
                'doc-row-added': item.added
              }"
            >
              <td class="cb-column" *ngIf="!isReadonly">
                <mat-checkbox
                  [checked]="item.selected"
                  (change)="documentSelectChange($event, item)"
                ></mat-checkbox>
              </td>
              <td>{{ item.signed ? "Ja" : "" }}</td>
              <td>
                <div class="montage-visible-cell-content">
                  <div style="text-align: center; flex: 1">
                    {{ item.montage_visible ? "Ja" : "Nein" }}
                  </div>

                  <button
                    mat-icon-button
                    (click)="toggleDocumentVisibility(item)"
                    style="border: 1px solid grey"
                    *ngIf="!isReadonly"
                  >
                    <mat-icon
                      *ngIf="item.montage_visible"
                      style="margin-top: -4px"
                      >visibility_off</mat-icon
                    >
                    <mat-icon
                      *ngIf="!item.montage_visible"
                      style="margin-top: -4px"
                      >visibility</mat-icon
                    >
                  </button>
                </div>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.updated }}</td>
              <td>{{ item.modifiedBy }}</td>
              <td>
                <div class="row-layout" style="align-items: center">
                  <app-download-document [data]="item"></app-download-document>
                  <div
                    *ngIf="item.canview"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-view-document
                    *ngIf="item.canview"
                    [data]="item"
                    (action)="onViewClick($event)"
                  ></app-view-document>
                  <div
                    *ngIf="item.canfill && canFillOrDelete && !isReadonly"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-fill-document
                    *ngIf="item.canfill && canFillOrDelete && !isReadonly"
                    [data]="item"
                    (done)="onDocumentEdit($event)"
                  ></app-fill-document>

                  <!-- TODO -->
                  <div
                    *ngIf="item.canprint"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-print-document
                    *ngIf="item.canprint"
                    [data]="item"
                  ></app-print-document>
                  <div
                    *ngIf="item.type === 'receipt' && !isReadonly"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-email-dialog-button
                    *ngIf="item.type === 'receipt' && !isReadonly"
                    [data]="item"
                    (action)="onEmailClick($event)"
                  >
                  </app-email-dialog-button>
                  <div
                    *ngIf="item.candelete && canFillOrDelete"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-delete-document
                    *ngIf="item.candelete && canFillOrDelete"
                    [data]="item"
                    (action)="onDeleteClick($event)"
                  ></app-delete-document>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <table class="orders-documents-table" *ngIf="_type !== 'all'">
        <thead
          class="bg-white pos-relative"
          style="top: 0; left: 0; z-index: 1000"
        >
          <tr>
            <th>Ausgefüllt</th>
            <!--
          <th>Sichtbar für Montage</th>
          -->
            <th style="max-width: 30vw">Name</th>
            <th>Geändert am</th>
            <th>Geändert von</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of rowDataStored; let $idx = index">
            <tr
              [id]="'doc_row_' + item.id"
              [ngClass]="{
                'table-grey-bg': $idx % 2 === 0 && !item.selected,
                'light-bg-color': item.selected,
                'doc-row-added': item.added
              }"
            >
              <td>{{ item.signed ? "Ja" : "" }}</td>
              <td style="padding: 16px">{{ item.name }}</td>
              <td>{{ item.updated }}</td>
              <td>{{ item.modifiedBy }}</td>
              <td>
                <div class="row-layout" style="align-items: center">
                  <div
                    *ngIf="item.canview"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-view-document
                    *ngIf="item.canview"
                    [data]="item"
                    (action)="onViewClick($event)"
                  ></app-view-document>

                  <div
                    *ngIf="item.canfill && canFillOrDelete && !isReadonly"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-fill-document
                    *ngIf="item.canfill && canFillOrDelete && !isReadonly"
                    [data]="item"
                    (done)="onDocumentEdit($event)"
                  ></app-fill-document>

                  <div
                    *ngIf="item.type === 'receipt' && !isReadonly"
                    class="montage-docs-action-separator"
                  ></div>
                  <app-email-dialog-button
                    *ngIf="item.type === 'receipt' && !isReadonly"
                    [data]="item"
                    (action)="onEmailClick($event)"
                  >
                  </app-email-dialog-button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div #docbuttons style="padding: 1rem 1rem 0.5rem 0" *ngIf="!isReadonly">
      <div class="row-layout" style="justify-content: space-between">
        <div class="doc-button-wrapper">
          <button mat-button (click)="addDocument()">
            <mat-icon>note_add</mat-icon>
            <span>Dokument hinzufügen</span>
          </button>
        </div>
        <div class="media-button-wrapper">
          <app-image-video
            type="image"
            label="Fotografieren"
            [orderid]="_id"
            [doctypes]="_doctypes"
            (done)="onMediaDone($event)"
          ></app-image-video>
        </div>
        <div class="media-button-wrapper">
          <app-image-video
            type="video"
            label="Video aufnehmen"
            [orderid]="_id"
            [doctypes]="_doctypes"
            (done)="onMediaDone($event)"
          ></app-image-video>
        </div>
      </div>

      <div class="doc-button-wrapper" *ngIf="_type === 'all'">
        <button mat-button (click)="mergeDocument()">
          <mat-icon>link</mat-icon>
          <span>Zu einem Dokument zusammenfügen</span>
        </button>
      </div>
      <div class="doc-button-wrapper" *ngIf="_type === 'all'">
        <button mat-button (click)="provideTeam()">
          <mat-icon>forward_to_inbox</mat-icon>
          <span>Für Montageteam bereitstellen</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!_showTable" class="light-font-color" style="margin: 32px auto">
    <h2>
      Auftrag muss erst gespeichert werden bevor mit Dokumenten gearbeitet
      werden kann.
    </h2>
  </div>
</div>
